var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "general-config" },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "config-form",
          attrs: { model: _vm.form, "label-width": "120px" },
        },
        [
          _c("div", { staticClass: "section-title" }, [_vm._v("品牌配置")]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.brandList,
                border: "",
                "header-cell-style": {
                  background: "#f5f7fa",
                  color: "#606266",
                  fontWeight: "bold",
                },
                "cell-style": { padding: "8px 0" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "brand", label: "品牌", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: {
                            placeholder: "请输入品牌名称",
                            size: "small",
                          },
                          model: {
                            value: scope.row.brand,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "brand", $$v)
                            },
                            expression: "scope.row.brand",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "supplierId", label: "通用ID", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: { placeholder: "请输入", size: "small" },
                          model: {
                            value: scope.row.supplierId,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "supplierId", $$v)
                            },
                            expression: "scope.row.supplierId",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "flowerId", label: "花喜ID", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: { placeholder: "请输入", size: "small" },
                          model: {
                            value: scope.row.flowerId,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "flowerId", $$v)
                            },
                            expression: "scope.row.flowerId",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "joyShareId", label: "乐享汇ID", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: { placeholder: "请输入", size: "small" },
                          model: {
                            value: scope.row.joyShareId,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "joyShareId", $$v)
                            },
                            expression: "scope.row.joyShareId",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "useType", label: "使用渠道", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: { placeholder: "请选择", size: "small" },
                            model: {
                              value: scope.row.useType,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "useType", $$v)
                              },
                              expression: "scope.row.useType",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { label: "花喜", value: "flower" },
                            }),
                            _vm._v(" "),
                            _c("el-option", {
                              attrs: { label: "乐享汇", value: "joy" },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticStyle: { color: "#F56C6C" },
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(scope.$index, scope.row)
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "add-btn",
              attrs: { type: "primary", plain: "", icon: "el-icon-plus" },
              on: { click: _vm.addBrand },
            },
            [_vm._v("添加")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-footer" },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "medium",
                    loading: _vm.submitting,
                  },
                  on: { click: _vm.submitForm },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { size: "medium" }, on: { click: _vm.resetForm } },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }